import React from "react";
import { DateInputMolecule, LabelMolecule, SelectDropdownMolecule, TextAreaMolecule, TextInputMolecule } from "..";
import { ContainerAtom } from "../../atoms";
import {
  CustomFieldConfig,
  DateFieldConfig,
  DropdownFieldConfig,
  FileFieldConfig,
  FormFieldConfig,
  GroupFieldConfig,
  TextAreaFieldConfig,
  TextFieldConfig,
} from "../../interfaces/FormConfig";
import { FileOrWeblocatieMolecule } from "../bestand-of-weblocatie";

type Props = {
  field: FormFieldConfig;
};

export const FormFieldRenderer: React.FC<Props> = ({ field }) => {
  switch (field.type) {
    case "text":
      return <TextField field={field} />;

    case "textArea":
      return <TextAreaField field={field} />;

    case "dropdown":
      return <DropdownField field={field} />;

    case "file":
      return <FileField field={field} />;

    case "date":
      return <DateField field={field} />;

    case "group":
      return <GroupField field={field} />;

    case "custom":
      return <CustomField field={field} />;

    default:
      throw new Error(`Onbekend veldtype: ${(field as FormFieldConfig).type}`);
  }
};

const TextField: React.FC<{ field: TextFieldConfig }> = ({ field }) => {
  return <TextInputMolecule {...field} />;
};

const TextAreaField: React.FC<{ field: TextAreaFieldConfig }> = ({ field }) => {
  return <TextAreaMolecule {...field} />;
};

const DropdownField: React.FC<{ field: DropdownFieldConfig<any> }> = ({ field }) => {
  return <SelectDropdownMolecule {...field} />;
};

const FileField: React.FC<{ field: FileFieldConfig }> = ({ field }) => {
  return <FileOrWeblocatieMolecule {...field} />;
};

const DateField: React.FC<{ field: DateFieldConfig }> = ({ field }) => {
  return <DateInputMolecule {...field} />;
};

const GroupField: React.FC<{ field: GroupFieldConfig }> = ({ field }) => {
  return (
    <>
      {field.label && <LabelMolecule label={field.label} tooltip={field.tooltip} required={field.required} />}
      <ContainerAtom type={field.layout}>
        {field.fields.map((child) => (
          <FormFieldRenderer key={child.id} field={child} />
        ))}
      </ContainerAtom>
    </>
  );
};

const CustomField: React.FC<{ field: CustomFieldConfig }> = ({ field }) => {
  return field.render();
};
